import { render, staticRenderFns } from "./Seguimiento.vue?vue&type=template&id=5d1a6d50&scoped=true"
import script from "./Seguimiento.vue?vue&type=script&lang=js"
export * from "./Seguimiento.vue?vue&type=script&lang=js"
import style0 from "./Seguimiento.vue?vue&type=style&index=0&id=5d1a6d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a6d50",
  null
  
)

export default component.exports